import { AnomalyGuids } from '@api/twin/AnomalyApi';
import { Stack } from '@stereograph/teia-system-design/components/Stack';
import { Bold } from '@stereograph/teia-system-design/components/Typography';
import { usePluginTranslation } from '@translation';
import { useMemo } from 'react';
import { createAnomalyScene } from '../../widgets/utils';
import { LoadAnomalySceneButton } from '../table/LoadAnomalySceneButton';

interface AnomalySceneBannerProps {
  anomalyGuids: AnomalyGuids;
}

export const AnomalySceneBanner = (props: AnomalySceneBannerProps) => {
  const { anomalyGuids } = props;
  const { t } = usePluginTranslation();

  const anomalyScene = useMemo(() => {
    return createAnomalyScene(anomalyGuids);
  }, [anomalyGuids]);

  const selectedCount = anomalyScene.selected.length;
  const visibleCount = anomalyScene.visible.length;
  const hiddenCount = anomalyScene.hidden.length;

  const selectedTranslation = t('anomaly_plugin.widget.scene_banner.selected_objects.label', {
    count: selectedCount,
  });
  const visibleTranslation = t('anomaly_plugin.widget.scene_banner.visible_objects.label', {
    count: visibleCount,
  });
  const hiddenTranslation = t('anomaly_plugin.widget.scene_banner.hidden_objects.label', {
    count: hiddenCount,
  });

  const boldContent = [selectedTranslation];
  boldContent.push(visibleCount > hiddenCount ? visibleTranslation : hiddenTranslation);

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      spacing={2}
      sx={{
        backgroundColor: (theme) => theme.palette.primary.light,
        paddingY: 2.5,
        paddingX: 4,
      }}
    >
      <Bold>{boldContent.join(', ')}</Bold>
      <Stack direction="row" spacing={2}>
        <LoadAnomalySceneButton anomalyScene={anomalyScene} />
      </Stack>
    </Stack>
  );
};
